import * as React from 'react';
import { PageSection } from '../../../atoms/layout/PageSection';
import { TopPageMultiCreatorBanner } from '../../multi_creator/TopPageMultiCreatorBanner';

export const MultiCreatorSection = () => {
    return (
        <PageSection title="NEW COURSE" subTitle="新コース" background="white" id={'multicreator-section'}>
            <TopPageMultiCreatorBanner className={'multicreator-banner-top'} />
        </PageSection>
    );
};
